import { BrowserRouter, Route, Routes } from "react-router-dom";
import "@ant-design/v5-patch-for-react-19";
import { ConfigProvider } from "antd";
import zhCN from "antd/locale/zh_CN";
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";
import LeftMenu from "./router/leftMenu";
import routes from "./router/index";
import "./App.css";
dayjs.locale("zh-cn");

function renderRoute() {
  let arr = [];
  routes.forEach((item, i) => {
    if (item.children) {
      item.children.forEach((citem, ci) => {
        arr.push(
          <Route
            key={i + "-" + ci}
            path={item.path + "/" + citem.path}
            element={citem.element}
          ></Route>
        );
      });
    } else {
      arr.push(<Route key={i} path={item.path} element={item.element}></Route>);
    }
  });
  return arr;
}

function App() {
  return (
    <div className="App">
      <ConfigProvider locale={zhCN}>
        <BrowserRouter>
          <div className="page-content">
            {window.location.pathname !== "/" && (
              <div
                style={{
                  width: 256,
                  height: "100%",
                  flexShrink: 0,
                  flexBasis: "auto",
                  overflow: "scroll",
                  background: "#55677ed1",
                }}
              >
                <LeftMenu />
              </div>
            )}
            <div
              className="app_main"
              style={{ padding: window.location.pathname === "/" ? 0 : 16 }}
            >
              <Routes>{renderRoute()}</Routes>
            </div>
          </div>
        </BrowserRouter>
      </ConfigProvider>
    </div>
  );
}

export default App;
